
type PayloadGTD = {
    event: string,
    data?: any
}

export const pushInfoToGoogleData = (payload:PayloadGTD ) => {
    if(window.dataLayer && process.env.REACT_APP_ENV !== 'development'){
        const dataTo = {
            event: payload.event,
            ...payload?.data,
        }
        window.dataLayer.push(dataTo);
    }
}
